import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { formatDate } from "@/lib/date";

const styles = StyleSheet.create({
  page: { padding: 32, fontSize: 11, fontFamily: "Helvetica" },
  section: { marginBottom: 14 },
  heading: { fontSize: 14, fontWeight: 700, marginBottom: 6, color: "#0F766E" },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 3 },
  divider: { borderBottomWidth: 1, borderBottomColor: "#CBD5E1", marginVertical: 10 },
  tableHeader: { flexDirection: "row", borderBottomWidth: 1, borderBottomColor: "#0F766E", paddingBottom: 4, marginBottom: 4 },
  tableRow: { flexDirection: "row", paddingVertical: 3, borderBottomWidth: 0.5, borderBottomColor: "#E2E8F0" },
  col1: { width: "22%" }, col2: { width: "14%" }, col3: { width: "14%" }, col4: { width: "18%" }, col5: { width: "16%" }, col6: { width: "16%" },
  th: { fontWeight: 700, fontSize: 9, color: "#334155" },
  td: { fontSize: 9, color: "#0F172A" },
  label: { color: "#64748B" },
});

export default function PrescriptionPDF({ patient, prescription }) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.heading}>Patient Information</Text>
          <View style={styles.row}><Text style={styles.label}>Patient Name</Text><Text>{patient.full_name}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Patient ID</Text><Text>{patient.patient_code}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Age / Gender</Text><Text>{patient.age || "-"} / {patient.gender || "-"}</Text></View>
          <View style={styles.row}><Text style={styles.label}>Date</Text><Text>{formatDate(prescription.created_at)}</Text></View>
        </View>

        <View style={styles.divider} />

        <View style={styles.section}>
          <Text style={styles.heading}>Prescription</Text>
          <View style={styles.tableHeader}>
            <Text style={[styles.th, styles.col1]}>Medicine</Text>
            <Text style={[styles.th, styles.col2]}>Strength</Text>
            <Text style={[styles.th, styles.col3]}>Dosage</Text>
            <Text style={[styles.th, styles.col4]}>Frequency</Text>
            <Text style={[styles.th, styles.col5]}>Before/After Food</Text>
            <Text style={[styles.th, styles.col6]}>Duration</Text>
          </View>
          {prescription.medicines.map((m, i) => (
            <View style={styles.tableRow} key={`${i}-${m.name}`}>
              <Text style={[styles.td, styles.col1]}>{m.name}</Text>
              <Text style={[styles.td, styles.col2]}>{m.strength}</Text>
              <Text style={[styles.td, styles.col3]}>{m.dosage}</Text>
              <Text style={[styles.td, styles.col4]}>{m.frequency}</Text>
              <Text style={[styles.td, styles.col5]}>{m.food_timing}</Text>
              <Text style={[styles.td, styles.col6]}>{m.duration}</Text>
            </View>
          ))}
        </View>

        {prescription.medicines.some((m) => m.instructions) && (
          <View style={styles.section}>
            <Text style={styles.heading}>Special Instructions</Text>
            {prescription.medicines.filter((m) => m.instructions).map((m, i) => (
              <Text key={`${i}-${m.name}`} style={styles.td}>{m.name}: {m.instructions}</Text>
            ))}
          </View>
        )}

        <View style={styles.divider} />

        <View style={styles.section}>
          <Text style={styles.heading}>Lifestyle Advice</Text>
          {prescription.diet_advice && <Text style={styles.td}>• Diet: {prescription.diet_advice}</Text>}
          {prescription.exercise_advice && <Text style={styles.td}>• Exercise: {prescription.exercise_advice}</Text>}
          {prescription.lifestyle_advice && <Text style={styles.td}>• Lifestyle: {prescription.lifestyle_advice}</Text>}
        </View>

        <View style={styles.divider} />

        <View style={styles.section}>
          <Text style={styles.heading}>Recommended Investigations</Text>
          <Text style={styles.td}>{prescription.investigations.join(", ") || "None"}</Text>
        </View>

        <View style={styles.divider} />

        <View style={styles.section}>
          <Text style={styles.heading}>Follow-up</Text>
          <Text style={styles.td}>Next Visit Date: {prescription.followup_date || "Not scheduled"}</Text>
          <Text style={styles.td}>Additional Notes: {prescription.followup_notes || "—"}</Text>
        </View>
      </Page>
    </Document>
  );
}
